Element.prototype.attachEvent = function attachEvent(ename, e) {
  this.addEventListener(ename, e);
};
